var $6e0d5294ecbb8ab6$exports = {};
$6e0d5294ecbb8ab6$exports = {
  "decrease": function decrease(args) {
    return "V\xE4henda ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Suurenda ".concat(args.fieldLabel);
  },
  "numberField": "Numbri v\xE4li"
};
export { $6e0d5294ecbb8ab6$exports as default };